import { useEffect, useState } from "react";
import { Users, UserPlus, ArrowsClockwise, Coins, Gift, Receipt } from "@phosphor-icons/react";
import api from "@/lib/api";
import { pts } from "@/lib/format";

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className="card-surface p-4 sm:p-5 fade-up">
    <Icon size={22} weight="duotone" className={accent ? "text-primary mb-3" : "text-muted-foreground mb-3"} />
    <p className={`font-display font-bold text-2xl sm:text-3xl ${accent ? "text-primary" : ""}`}>{value}</p>
    <p className="text-xs text-muted-foreground mt-1">{label}</p>
  </div>
);

export default function BizDashboard() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/business/dashboard").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return <div className="text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display font-bold text-2xl sm:text-3xl">Dashboard</h1>
        <p className="text-muted-foreground text-sm">Your loyalty program at a glance.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <Stat icon={Users} label="Customers today" value={d.customers_today} accent />
        <Stat icon={UserPlus} label="New customers" value={d.new_customers} />
        <Stat icon={ArrowsClockwise} label="Returning" value={d.returning_customers} />
        <Stat icon={Receipt} label="Transactions today" value={d.transactions_today} />
        <Stat icon={Coins} label="Points issued today" value={pts(d.points_issued_today)} accent />
        <Stat icon={Gift} label="Rewards redeemed today" value={d.rewards_redeemed_today} />
        <Stat icon={Users} label="Total customers" value={d.total_customers} />
      </div>

      <div className="card-surface p-4 sm:p-6">
        <h2 className="font-display font-semibold text-lg mb-4">Top rewards</h2>
        {d.top_rewards.length === 0 ? (
          <p className="text-sm text-muted-foreground">No redemptions yet.</p>
        ) : (
          <div className="space-y-3">
            {d.top_rewards.map((r, i) => (
              <div key={i} className="flex items-center justify-between">
                <span className="text-sm">{r.name}</span>
                <span className="font-display font-semibold text-primary">{r.count}×</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
